<a role="button" class="w-full gap-2 flex mb-3 cursor-pointer backToButton text-gray-900 server-pdf-btn"
    (click)="downloadDetail($event)"
    [class.disabled]="isAnyServerPdfBusy"
    [class.is-loading]="busy.detail"
    [attr.aria-busy]="busy.detail ? 'true' : null">
    <span *ngIf="!busy.detail">{{'Key.DetailPdfDownload' | translate}}</span>
    <span *ngIf="busy.detail">{{ downloadingLabel }}</span>
    <i *ngIf="busy.detail" class="pi pi-spin pi-spinner icon-width"></i>
    <img *ngIf="!busy.detail" class="icon-width" src="assets/vinter/icons/download-icon.svg">
</a>

<a role="button" class="w-full gap-2 flex mb-3 cursor-pointer backToButton text-gray-900 server-pdf-btn"
    (click)="downloadSummary($event)"
    [class.disabled]="isAnyServerPdfBusy"
    [class.is-loading]="busy.summary"
    [attr.aria-busy]="busy.summary ? 'true' : null">
    <span *ngIf="!busy.summary">{{'Key.SummaryPdfDownload' | translate}}</span>
    <span *ngIf="busy.summary">{{ downloadingLabel }}</span>
    <i *ngIf="busy.summary" class="pi pi-spin pi-spinner icon-width"></i>
    <img *ngIf="!busy.summary" class="icon-width" src="assets/vinter/icons/download-icon.svg">
</a>

<div *ngIf="showDownloadAIReportBtn" class="flex align-items-center flex-nowrap">
    <img src="assets/vinter/icons/crown.svg" width="18" height="18" *ngIf="!isAIReportLicenseValid" class="-mt-3 -ml-1 mb-1">
    <a role="button"
        class="w-full gap-2 flex mb-3 cursor-pointer backToButton text-gray-900 server-pdf-btn"
        (click)="downloadAI($event)"
        [class.disabled]="isAnyServerPdfBusy"
        [class.is-loading]="busy.ai"
        [attr.aria-busy]="busy.ai ? 'true' : null">
        <span *ngIf="!busy.ai">{{ 'Key.AIBasedDownload' | translate }}</span>
        <span *ngIf="busy.ai">{{ downloadingLabel }}</span>
        <i *ngIf="busy.ai" class="pi pi-spin pi-spinner icon-width"></i>
        <img *ngIf="!busy.ai && isAIReportLicenseValid" class="icon-width" src="assets/vinter/icons/download-icon.svg">
    </a>
</div>
